<template>
  <div class="containerMod">
    <div v-if="loading" class="loading-container">
      <div class="loader"></div>
    </div>
    <div v-else>
      <div class="bloqueFicha" v-for="postal in postales" :key="postal._id">
        <div class="imgPost">
          <div>
            <img class="portada" v-show="postal.imagen" :src="postal.imagen"/>
            <img class="portada" v-show="!(postal.imagen)" src='@/assets/PortadaND.png'/>
          </div>
          <div>
            <img class="portada" v-show="postal.imagen2" :src="postal.imagen2"/>
            <img class="portada" v-show="!(postal.imagen2)" src='@/assets/PortadaND.png'/>
          </div>
        </div>
        <div class="contenido">
          <div class="linea1">
            {{postal.titulo}}
          </div>
          <div class="linea2">
            {{postal.pais ? (postal.pais) : `` }}
          </div>
          <div class="linea3">
            {{postal.fecha ? (postal.fecha) : `` }}
          </div>
          <div class="linea3">
            {{postal.comments ? (postal.comments) : ``}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import XCerrarModal from './XCerrarModal.vue'
import axios from 'axios'
export default {
  // components: { XCerrarModal },
  name: 'ShowPostales',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getPostales()
  },
  data () {
    return {
      postales: [],
      URLbase: '',
      loading: false
    }
  },
  methods: {
    async getPostales () {
      try {
        this.loading = true
        const url = `${this.URLbase}/postales/getPostales`
        const res = await axios.get(url)
        this.postales = res.data
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod {
  overflow-y: auto;
  height: 99%;
  margin-top: 3px;
  background-color: var(--gr-fo-for);
  color:rgb(2, 2, 2);
}
.bloqueFicha{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 26% 70%;
}
.imgPost{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.portada{
  width: 130px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
}
.portadaND{
  width: 120px;
  height: 170px;
  border: solid 0.5px rgb(63, 193, 253);
  border-radius: 5px;
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items:flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.linea1{
  font-weight: bold;
  font-size: 17px;
  color: rgb(30, 119, 161);
}
.linea2{
  font-size: 14px;
  font-weight:800;
}
.linea3{
  font-size: 14px;
  text-align: left;
}.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 576px){
 .containerMod{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
 }
 .bloqueFicha{
  display: flex;
  flex-direction: column;
  width: 80%;
  margin-left:auto;
  margin-right:auto;
  }
  .portada{
    width: 230px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .portadaND{
    width: 200px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .contenido{
    width:100%;
    padding-left: 0;
  }
  .linea1, .linea2, .linea3{
    text-align: left;
    width: 100%
  }
  .linea2{
    margin:4px 0 4px;
  }
}
</style>
